import axios from 'axios';

const apiWeb = axios.create({ baseURL: 'http://maxauto.com.br:8000/api/' });
// const apiWeb = axios.create({ baseURL: 'http://localhost:8000/api/' });

export default apiWeb;
